import { ReactElement, useEffect, useRef, useState } from "react";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import DesignServicesIcon from '@mui/icons-material/DesignServices';

function FileList({field, form}: {field: any, form: any}) : ReactElement {


    return(
        <div className="w-2/3 h-full max-h-[16rem] overflow-y-auto px-2">
            {field?.value?.map((f: any, i: number) => {
                return(
                    <div key={`${f.name}-${i}`} className="w-full mb-2 px-4 h-10 flex border rounded items-center justify-between">
                        <div>{f.name}</div>
                        <DeleteIcon onClick={()=> {
                          const newFileArray = field.value.filter((file: any) => file.name !== f.name);
                          console.log("New file array: "  , newFileArray );
                          form.setFieldValue(field.name, newFileArray);
                        }} className="text-red-400 cursor-pointer"/>
                    </div>
                )

            })}
        </div>
    )
}

type FieldInputProps = {
  field: {name: string, value: File[]},
  form: {setFieldValue: (name: string, value: File[]) => void},
  title?: string,
  icon: ReactElement
}

// drag drop file component
export function FileUploader({form, field, title, icon} : FieldInputProps) {


    // drag state
    const [dragActive, setDragActive] = useState(false);
    
    // ref
    const inputRef = useRef<any>(null);
    
    // handle drag events
    const handleDrag = function(e : any) {
      e.preventDefault();
      e.stopPropagation();
      if (e.type === "dragenter" || e.type === "dragover") {
        setDragActive(true);
      } else if (e.type === "dragleave") {
        setDragActive(false);
      }
    };
    
    // triggers when file is dropped
    const handleDrop = function(e : any) {
      e.preventDefault();
      e.stopPropagation();
      setDragActive(false);
      console.log("Received files: ", e.dataTransfer.files)
      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        const files = e.dataTransfer.files;
        form.setFieldValue(field.name, [...field.value, ...files]);
      }
    };
    
    // triggers when file is selected with click
    const handleChange = function(e : any) {
      e.preventDefault();
      if (e.currentTarget.files) {
        const files = e.currentTarget.files;
        form.setFieldValue(field.name, [...(field.value || []), ...files]);
      }
    };
    
  // triggers the input when the button is clicked
    const onButtonClick = () => {
      inputRef.current.click();
    };
    
    return (<div className="flex w-full border rounded p-5">
      <div id="form-file-upload" className="h-[6rem] w-1/3 max-w-full text-center relative" onClick={onButtonClick} onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
        <input ref={inputRef} className={'hidden'} type="file" id="input-file-upload" multiple={true} onChange={handleChange} />
        <label className={`h-full flex justify-center items-center content-center border-2 border-dashed rounded-lg cursor-pointer hover:bg-zinc-100 border-zinc-400 bg-zinc-300 ${dragActive ? "bg-zinc-100" : ""} `} id="label-file-upload" htmlFor="input-file-upload" >
          <div>
            <div  className={`${dragActive ? 'animate-bounce' : ''}`}>
            {icon ? icon : <DesignServicesIcon style={{fontSize: '2.5em'}}/>}
            </div>
            <p className="pt-1 font-bold">{title? title : `Desenhos técnicos`}</p>
          </div> 
        </label>
        { dragActive && <div id="drag-file-element" className="absolute w-full h-full rounded top-0 right-0 bottom-0 left-0" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div> }
      </div>
        
        <FileList field={field} form={form}/>
        
      </div>
    );
  };